import * as React from 'react';
const SvgExternalLink = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" {...props}>
        <path
            d="M13 8.503a1 1 0 011 1v3a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-11a1.5 1.5 0 011.5-1.5h3a1 1 0 110 2H2v10h10v-2.5a1 1 0 011-1zm-1.7-6.716v-.323l-1.15.314a6.258 6.258 0 01-1.65.221c-.6 0-1-.447-1-1a1 1 0 011-1H13a1 1 0 011 1v4.504a1 1 0 01-1 1c-.552 0-1-.403-1-1a6.3 6.3 0 01.222-1.656l.313-1.147h-.32l-1.078 1.437a9.996 9.996 0 01-.93 1.072l-3.5 3.498a1 1 0 11-1.414-1.414l3.5-3.5c.334-.332.69-.64 1.065-.923L11.3 1.787z"
            fill="currentColor"
        />
    </svg>
);
export default SvgExternalLink;
